export const ORGANISATION_LOCAL = 'local';
export const ORGANISATION_DEVELOPMENT = 'development';
export const ORGANISATION_MY_HUNTER_DEV = 'my-hunter-dev';
export const ORGANISATION_MY_HUNTER = 'my-hunter';
export const ORGANISATION_THE_BIG_DEV = 'the-big-dev';
export const ORGANISATION_THE_BIG_PR = 'the-big-pr';
export const ORGANISATION_THE_BIG = 'the-big';

const CONFIG = {
  ITEMS_PER_PAGE: 25,
  ORGANISATIONS: {
    [ORGANISATION_LOCAL]: {
      name: 'Local development',
      api_endpoint: 'http://localhost:8000/',
      auto_detect_host: 'localhost',
    },
    [ORGANISATION_DEVELOPMENT]: {
      name: 'Development',
      api_endpoint: 'https://api.dev.big.policypilot.ai/',
      auto_detect_host: 'app.policypilot.ai',
    },
    [ORGANISATION_MY_HUNTER_DEV]: {
      name: 'My Hunter Dev',
      api_endpoint: 'https://api.dev.my-hunter.policypilot.ai/',
      auto_detect_host: 'myhunter.dev.policypilot.ai',
    },
    [ORGANISATION_MY_HUNTER]: {
      name: 'My Hunter',
      api_endpoint: 'https://api.my-hunter.policypilot.ai/',
      auto_detect_host: 'myhunter.policypilot.ai',
    },
    [ORGANISATION_THE_BIG_DEV]: {
      name: 'The Big Dev',
      api_endpoint: 'https://api.dev.big.policypilot.ai/',
      auto_detect_host: 'big.dev.policypilot.ai',
    },
    [ORGANISATION_THE_BIG_PR]: {
      name: 'The Big PR',
      api_endpoint: 'https://api.pr.big.policypilot.ai/',
      auto_detect_host: 'big.pr.policypilot.ai',
    },
    [ORGANISATION_THE_BIG]: {
      name: 'The Big',
      api_endpoint: 'https://api.big.policypilot.ai/',
      auto_detect_host: 'precisionx.thebig.ca',
    },
  },
};

export default CONFIG;
